import React, {Fragment} from 'react';
import _ from 'lodash';
import {compose} from "redux";
import {translate} from 'react-i18next';
import {connect} from "react-redux";
import {getArtefactTripletFromUrn, getStringFromArtefactTriplet} from "../../../utils/sdmxJson";
import {Button, Col, Form, Icon, Row} from "antd";
import {
  GUTTER_MD,
  MARGIN_MD,
  MARGIN_SM,
  SPAN_FULL,
} from "../../../styles/constants";
import FileInput from "../../../components/file-input";
import EnhancedModal from '../../../components/enhanced-modal';
import { 
    uploadImportStructures20File,
    changeImportStructuresForm,
    submitImportStructures20,
    hideImportStructures20Report,
    resetImportStructures20
} from './actions';

const mapStateToProps = state => ({
    file: state.scenes.utilities.importStructures20.file,
    items: state.scenes.utilities.importStructures20.items,
    hash: state.scenes.utilities.importStructures20.hash,
    report: state.scenes.utilities.importStructures20.report,
    selectedItems: state.scenes.utilities.importStructures20.selectedItems
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(changeImportStructuresForm(fields)),
  onFileUpload: file => dispatch(uploadImportStructures20File(file)),
  onSubmit: (structures, hash) => dispatch(submitImportStructures20(structures, hash)),
  onReportHide: () => dispatch(hideImportStructures20Report()),
  onReset: () => dispatch(resetImportStructures20()),
});

const mapPropsToFields = ({file}) => ({
    file: Form.createFormField({value: file})
});

const onFieldsChange = (props, fields) =>
  props.onChange(_.mapValues(fields, ({value}) => value));

const IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS = "Success";
const IMPORT_STRUCTURES_REPORT_STATUS_WARNING = "Warning";
const IMPORT_STRUCTURES_REPORT_STATUS_ERROR = "Error";
const IMPORT_STRUCTURES_REPORT_STATUS_FAILURE = "Failure";

const ImportStructures20 = ({
                                t,
                                form,
                                file,
                                items,
                                hash,
                                onFileUpload,
                                onSubmit,
                                report,
                                onReportHide,
                                onReset
                            }) =>
    <Fragment>
        <EnhancedModal
          visible={report !== null}
          title={t('scenes.utilities.importStructures.reportModal.title')}
          onCancel={onReportHide}
          footer={<Button onClick={onReportHide}>{t('commons.buttons.close.title')}</Button>}
        >
          {
            items !== null && report !== null
              ? (
                report.map(({maintainableObject, status, result, isFinal}, index) => {
                  const triplet = getArtefactTripletFromUrn(maintainableObject);
                  return (
                    <Fragment key={index}>
                      <Row type="flex" justify="space-between" style={index > 0 ? {marginTop: MARGIN_MD} : null}>
                        <Col>
                          {(() => {
                            const item = items.filter(item =>
                              item.id === triplet.id && item.agency === triplet.agencyID && item.version === triplet.version
                            )[0];
                            return (
                              <Fragment>
                                {(item ? (item.type + " ") : "") +
                                "[" + getStringFromArtefactTriplet(triplet) + "] "}
                                <b>
                                  {(isFinal
                                      ? t("data.artefact.isFinal.values.final")
                                      : t("data.artefact.isFinal.values.notFinal")
                                  ).toLowerCase()}
                                </b>
                              </Fragment>
                            );
                          })()}
                        </Col>
                        <Col>
                          {status === IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS && (
                            <Fragment>
                              {`${t('scenes.utilities.importStructures.reportModal.status.success')} `}
                              <Icon type="check-circle" theme="filled" style={{color: 'green'}}/>
                            </Fragment>
                          )}
                          {status === IMPORT_STRUCTURES_REPORT_STATUS_WARNING && (
                            <Fragment>
                              {`${t('scenes.utilities.importStructures.reportModal.status.warning')} `}
                              <Icon type="exclamation-circle" theme="filled" style={{color: 'orange'}}/>
                            </Fragment>
                          )}
                          {status === IMPORT_STRUCTURES_REPORT_STATUS_ERROR && (
                            <Fragment>
                              {`${t('scenes.utilities.importStructures.reportModal.status.error')} `}
                              <Icon type="close-circle" theme="filled" style={{color: 'red'}}/>
                            </Fragment>
                          )}
                          {status === IMPORT_STRUCTURES_REPORT_STATUS_FAILURE && (
                            <Fragment>
                              {`${t('scenes.utilities.importStructures.reportModal.status.error')} `}
                              <Icon type="close-circle" theme="filled" style={{color: 'red'}}/>
                            </Fragment>
                          )}
                        </Col>
                      </Row>
                      {status !== IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS && (
                        <i>{result}</i>
                      )}
                    </Fragment>
                  );
                })
              )
              : null
          }
        </EnhancedModal>
        <Row type="flex" justify="center">
            <Col span={SPAN_FULL}>
                <Row type="flex" justify="center">
                    <Col>
                        <Row type="flex" align="middle" gutter={GUTTER_MD} justify="center">
                            <Col style={{width: 480}}>
                                <Form className='advanced-form'>
                                    <Form.Item className="form-item-required" label={t('data.csv.file.label')}>
                                    {form.getFieldDecorator('file')(
                                        <FileInput accept={".xml"}/>
                                    )}
                                    </Form.Item>
                                </Form>
                            </Col>
                            <Button
                              icon="upload"
                              type="primary"
                              onClick={() => onFileUpload(file)}
                              disabled={items !== null || file === null}
                              style={{marginRight: MARGIN_SM}}
                            >
                                {t('data.xml.uploadButton.label')}
                            </Button>
                            {items !== null && (
                              <Button
                                icon="delete"
                                onClick={onReset}
                                disabled={items === null}
                              >
                                {t('scenes.utilities.importStructures.resetButton.label')}
                              </Button>
                            )}
                        </Row>
                    </Col>
                </Row>
                <Row type='flex' align='end'>
                  {items !== null && (
                      <Button
                        icon="check"
                        type="primary"
                        onClick={() => onSubmit(items, hash)}
                        disabled={!items || items.length === 0}
                      >
                        {t('scenes.utilities.importStructures.table.import.submit.title')}
                      </Button>
                    )}
                </Row>
            </Col>
        </Row>
    </Fragment>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(ImportStructures20);